import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { User } from '@core/models/user';
import { ApplicationService } from '@core/services/application.service';
import { ConfigService } from '@core/services/config.service';
import { FeatureFlagService } from '@core/services/feature-flag.service';
import { FeatureFlagOptions } from '@core/models/featureFlagOptions';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
	host: { 'class': 'home' }
})
export class HomeComponent implements OnInit {

	user: User;
	showIntake: boolean;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private applicationService: ApplicationService,
		private configService: ConfigService,
		private featureFlagService: FeatureFlagService
	) {

		this.user = new User();
		this.showIntake = true;
	}

	ngOnInit() {

		let config = this.configService.getConfig();
		this.applicationService.updateSettings(config.residence.displayName, false, true);

		this.activatedRoute.data.pipe(map(data => data.user))
			.subscribe((user: User) => {

				this.user.hasFullAccess = user.hasFullAccess;
				this.user.hasLoketAccess = user.hasLoketAccess;
				this.user.hasWorkshopAccess = user.hasWorkshopAccess;
			});

			this.featureFlagService.getIntakeFeature().then((flagOptions: FeatureFlagOptions) => {				
				this.showIntake = !(flagOptions.enabled && flagOptions.isBlocked);
			}).catch(error => {
				console.error('Error fetching intake feature flag options:', error);
			});
	}

	returnClassName() {

		if(this.user.hasFullAccess && this.showIntake) {
			return "full"
		}
		else if(this.user.hasFullAccess && !this.showIntake) {
			return "full-no-intake"
		}
		else if(this.user.hasLoketAccess && this.showIntake) {
			return "loket"
		}
		else if(this.user.hasLoketAccess && !this.showIntake) {
			return "loket-no-intake"
		}
		else if(this.user.hasWorkshopAccess ) {
			return "workshop"
		}				
	}

	onKey(searchValue: string) {

		this.router.navigate(['/dossier/list'], { queryParams: { search: searchValue } });
	}
}
